module.exports = __webpack_public_path__ + "img/circle-plus.4f9866f9.svg";